import { useCallback, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { signinUser } from '../../../services/users';
import _ from 'lodash';

export function LoginForm({ onLoginSuccess }: { onLoginSuccess: (arg: unknown) => void }) {
  type LoginFormInput = { email: string; password: string };

  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormInput>();

  const handleLogin: SubmitHandler<LoginFormInput> = useCallback(
    async (data) => {
      setLoading(true);
      if (data.email !== '' && data.password !== '') {
        try {
          const user = await signinUser({
            username: data.email,
            password: data.password,
          });
          console.log(user);
          setLoading(false);
          onLoginSuccess(user);
        } catch (error) {
          setLoading(false);
          if (_.has(error, 'code')) {
            switch (_.get(error, 'code')) {
              case 'NotAuthorizedException':
                alert('Invalid email or password');
                break;

              case 'UserNotFoundException':
                alert('An account with this email address does not exist');
                break;
            }
          }
        }
      }
    },
    [onLoginSuccess]
  );

  return (
    <form action="#" className="w-full" onSubmit={handleSubmit(handleLogin)}>
      <div className="mt-4 w-full">
        <label htmlFor="username">
          Email
          <input data-testid="usernameInput" id="username" type="text" placeholder="e.g. you@gmail.com" {...register('email', { required: true })} />
          {errors['email'] && <span className="text-sm text-ginger font-raleway-italic">Email is required</span>}
        </label>
      </div>
      <div className="mt-4 w-full">
        <label htmlFor="password">
          Password
          <input data-testid="passwordInput" id="password" type="password" placeholder="*******" {...register('password', { required: true })} />
          {errors['password'] && <span className="text-sm text-ginger font-raleway-italic">Password is required</span>}
        </label>
      </div>
      <div className="mt-4 flex items-center place-content-between w-full text-[11px]">
        <div className="flex items-center gap-2">
          <input type="checkbox" data-testid="rememberMeCheckbox" /> Remember me
        </div>
        <Link to="/auth/forgot-password">Forgot password?</Link>
      </div>
      <div className="mt-5 w-full">
        {!loading && (
          <button data-testid="loginButton" className="block text-center bg-periwinkle text-white p-3 rounded-full text-lg w-full">
            Log In
          </button>
        )}
        {loading && <span>Loading...</span>}
      </div>
    </form>
  );
}
